import React, { FC, useState } from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import { ExtendedTheme, Link } from 'neon-design-system';
import UpdateCardDialog from '../../ui/UpdateCardDialog';

export interface UpdateCardButtonProps {
	subscriptionId: string;
	align?: 'center' | 'left';
	colorType?: 'primary' | 'secondary';
	linkClassName?: string;
	onStripeCardUpdated: () => void;
}

const useStyles = makeStyles<ExtendedTheme, Partial<UpdateCardButtonProps>>((theme: ExtendedTheme) => createStyles({
	disclaimer: {
		color: theme.themeColors.blueGrey[200]
	},
	button: {
		backgroundColor: ({ colorType }) => colorType === 'secondary' ? theme.themeColors.secondary[700] : undefined
	},
	buttonWrapper: ({ align }) => align === 'center' ? {
		display: 'flex',
		gap: 8,
		alignItems: 'center',
		flexDirection: 'column'
	} : {}
}));

export const UpdateCardButton: FC<UpdateCardButtonProps> = ({ subscriptionId, align = 'center', colorType = 'secondary', linkClassName, onStripeCardUpdated }) => {
	const [isUpdateCardDialogVisible, setIsUpdateCardDialogVisible] = useState(false);
	const classes = useStyles({ align, colorType });

	const onClick = () => {
		setIsUpdateCardDialogVisible(true);
	};

	return <>
		<UpdateCardDialog
			subscriptionId={subscriptionId}
			isDialogOpen={isUpdateCardDialogVisible}
			closeDialog={() => setIsUpdateCardDialogVisible(false)}
			onStripeCardUpdated={onStripeCardUpdated}>
		</UpdateCardDialog>
		<div className={classes.buttonWrapper}>
			<Link onClick={onClick} className={linkClassName}><strong>Edit payment details</strong></Link>
		</div>
	</>;
}